<template>
  <v-btn class="cart-btn" icon="mdi-cart" color="#F1F1F1" flat rounded="pill">
    <v-icon>mdi-cart</v-icon>
    <span
      :class="{ langBage: isLongCounter }"
      v-if="counter > 0"
      class="v-badge"
      >{{ counter }}</span
    >
  </v-btn>
</template>

<script>
export default {
  props: {
    counter: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isLongCounter() {
      if (this.counter >= 10) return true;
      else return false;
    },
  },
};
</script>

<style lang="scss">
@media (max-width: 425px) {
  .cart-btn {
    .v-icon {
      font-size: 23px !important;
    }
  }
}
</style>

<style scoped lang="scss">
.cart-btn {
  .v-badge {
    background-color: #bd9478;
    letter-spacing: 0;
    z-index: 1;
    border: 3px white solid;
    color: white;
    font-size: 15px;
    padding: 1px 3px;
    font-weight: 400;
    border-radius: 50%;
    position: absolute;
    top: -10px;
    right: -8px;
    &.langBage {
      padding: 4px 3px;
    }
  }
}
@media (max-width: 425px) {
  .cart-btn {
    height: 40px !important;
    width: 40px !important;
  }

  .v-badge {
    font-size: 13px !important;
    border: 1px white solid !important;
    top: -3px !important;
    right: -5px !important;
  }
}
</style>
